import { Tr, Td } from 'app/common/ui-components/table'

import type { PurchaseItem } from '../ordersPurchasesConvert'
import { ids } from './columnsByComplexes'


type Props = {
  disabled: boolean
} & PurchaseItem

export const OOPByComplexesRow = ({ disabled, ...purchaseItemProps }: Props) => {
  return (
    <Tr disabled={disabled}>
      {ids.map(colId => (
        <Td key={colId}>
          {purchaseItemProps[colId]}
        </Td>
      ))}
    </Tr>
  )
}
